import toast from 'react-hot-toast';

const initActions = function (services) {
    const axiosCall = services.axios.Axios();

    const getAccounts = () => async () => {
        try {
            var response = await axiosCall.get('accounts');
            return response.data;
        } catch (err) {
            console.error(err);
        }
    };

    // TODO: add error handling to this
    const getAccount = (accountId) => async () => {
        try {
            return await axiosCall
                .get('accounts/' + accountId)
                .then((res) => res.data);
        } catch (error) {
            const errorMsg = error.message;
            toast(
                () => (
                    <div className="text-light d-flex justify-content-between w-100">
                        Error: Something went wrong fetching this account
                        {errorMsg}
                    </div>
                ),
                {
                    duration: 7500,
                    style: {
                        minWidth: '25vw',
                        background: 'red',
                    },
                }
            );
            return error;
        }
    };

    const createAccount = (payload) => async () =>
        axiosCall
            .post('accounts', { ...payload })
            .then((res) => res.data)
            .catch((error) => {
                throw error;
            });

    const updateAccount = (id, payload) => async () => {
        try {
            await axiosCall.patch('accounts/' + id, {
                ...payload,
            });
        } catch (err) {
            throw err;
        }
    };

    const getAccountsToAssignPartner = (partnerId) => async () =>
        axiosCall.get('accounts/withPartnerDomains?partnerId=' + partnerId);

    const addAccountToPartner = (partnerId, accountId) => async () =>
        axiosCall.post(
            'accounts/addToPartner',
            {
                id: accountId,
            },
            { params: { partnerId: partnerId } }
        );

    const removeAccountFromPartner = (partnerId, accountId) => async () =>
        axiosCall.delete('accounts/deleteFromPartner', {
            params: { partnerId: partnerId, accountId: accountId },
        });

    return {
        addAccountToPartner,
        createAccount,
        getAccount,
        getAccounts,
        getAccountsToAssignPartner,
        removeAccountFromPartner,
        updateAccount,
    };
};

export default initActions;
